export default __webpack_public_path__ + "static/media/car.35f758d4.svg";